var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1511 9C20.1511 13.5641 16.4937 17.25 11.9994 17.25C7.50506 17.25 3.84766 13.5641 3.84766 9C3.84766 4.43587 7.50506 0.75 11.9994 0.75C16.4937 0.75 20.1511 4.43587 20.1511 9Z",
    stroke: "#303030",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4587 0.927734V0.927734C5.99243 4.19655 5.99243 13.4304 12.4587 16.6992V16.6992",
    stroke: "#303030",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5413 0.927734V0.927734C18.0076 4.19655 18.0076 13.4304 11.5413 16.6992V16.6992",
    stroke: "#303030",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8828 6.49414V6.49414C14.4684 4.7089 9.53309 4.7089 5.11872 6.49414V6.49414",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11719 11.1331V11.1331C9.53155 12.9183 14.4669 12.9183 18.8813 11.1331V11.1331",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0938 0.378906V17.8105",
    stroke: "#303030",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonal);
export default __webpack_public_path__ + "static/media/Personal.19f5a1f509e1fb4cd95bca0e44ec86ad.svg";
export { ForwardRef as ReactComponent };